export const SET_CONFIG_PAGE_REDUCER = 'teamly/settings/SET_CONFIG_REDUCER';

export default (state = [{ configPageReducer: '' }], action: any) => {
  switch (action.type) {
    case SET_CONFIG_PAGE_REDUCER:
      const { configPageReducer } = action;
      return {
        ...state,
        configPageReducer,
      };
    default:
      return state;
  }
};

export const setConfigPageReducer = (configPageReducer: any) => ({
  type: SET_CONFIG_PAGE_REDUCER,
  configPageReducer,
});
